import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

export default class extends Controller {
  static targets = ['style_vendor', 'color', 'size', 'category'];

  initialize() {
    this.initialDataTablesSku();
    this.initialDataTablesPocInhouse();
    this.showImportError();
  }

  change(event) {
    const style_vendor = event.target.selectedOptions[0].getAttribute('style_vendor');
    const color = event.target.selectedOptions[0].getAttribute('color');
    const size = event.target.selectedOptions[0].getAttribute('size');
    const category = event.target.selectedOptions[0].getAttribute('category');
    this.poc(style_vendor, color, size, category);
  }

  poc(style, color, size, category) {
    this.style_vendorTarget.value = style;
    this.colorTarget.value = color;
    this.sizeTarget.value = size;
    this.categoryTarget.value = category;
  }

  confirmDelete(e) {
    $(`#modalCancel${e.target.id}`).trigger('click');
    this.myModal($(`#confirmDeleteModal-${e.target.id}`)).show();
  }

  cancelDelete(e) {
    this.myModal($(`#editskuModalToggle${e.target.id}`)).show();
  }

  toggleEditValue(e) {
    const id = e.params.id;
    const element = $(`#newQty-${id}`);

    element.prop('disabled', !element.prop('disabled'));
  }

  setQty(e) {
    const id = e.params.id;
    let stockQty = parseInt(document.getElementById(`stockQty-${id}`).value);
    stockQty = stockQty > 0 ? stockQty : 0;
    const newQty = parseInt(e.target.value);
    const needQty = parseInt(document.getElementById(`needQty-${id}`).value);

    if (newQty >= needQty - stockQty) {
      $(`[name="product-detail"][id="${id}"]`)
        .find('input[name="poc[item_details_attributes][][qty]"]')
        .val(newQty);
    }
  }

  myModal(element) {
    return new bootstrap.Modal(element, { keyboard: false });
  }

  initialDataTablesSku() {
    const table = 'table#pocSkuLists';

    if (!$(table).length) {
      return;
    }

    if (!$.fn.DataTable.isDataTable(table)) {
      $(table).dataTable({
        columnDefs: [{ orderable: false, targets: 'nosort' }],
        order: [],
      });
    }

    document.addEventListener('turbo:before-cache', () => {
      const table = $('table#pocSkuLists');

      if (!table.length) {
        return;
      }

      const tableConstant = table.DataTable();
      tableConstant.destroy();
    });
  }

  initialDataTablesPocInhouse() {
    const table = 'table#pocInhouseTable';

    if (!$(table).length) {
      return;
    }

    if (!$.fn.DataTable.isDataTable(table)) {
      $(table).dataTable({
        columnDefs: [{ orderable: false, targets: 'nosort' }],
        order: [],
      });
    }

    document.addEventListener('turbo:before-cache', () => {
      const table = $('table#pocInhouseTable');

      if (!table.length) {
        return;
      }

      const tableConstant = table.DataTable();
      tableConstant.destroy();
    });
  }

  showImportError() {
    try {
      const message = document.getElementById('import-error').dataset.message;
      if (message) {
        this.myModal($('#template-error')).show();
      }
    } catch (e) {
      // Do nothing
    }
  }

  toggleSelectAllPocInhouse(e) {
    const isChecked = e.target.checked;
    const table = $('table#pocInhouseTable').DataTable();
    const rows = table.rows({ search: 'applied' }).nodes();

    rows.each((element, _) => {
      const id = element.id;
      const qtyInput = $(rows).find(`#newQty-${id}`);
      const checkbox = $(rows).find(`input[type="checkbox"][data-id="${id}"]`);
      const destroyInput = $(`div#${id} input[name="poc[item_details_attributes][][_destroy]"]`);

      qtyInput.prop('disabled', !isChecked);
      checkbox.prop('checked', isChecked);
      destroyInput.val(!isChecked);
    });
  }

  toggleSelectPocInhouse(e) {
    const isChecked = e.target.checked;
    const id = $(e.currentTarget).data('id');

    const qtyInput = $(`#newQty-${id}`);
    const destroyInput = $(
      `div[id="${id}"] input[name="poc[item_details_attributes][][_destroy]"]`,
    );

    qtyInput.prop('disabled', !isChecked);
    destroyInput.val(!isChecked);
  }

  submitFormInhouse() {
    const form = document.getElementById('form-poc-inhouse');
    if (form.checkValidity()) {
      this.openSpinner();
      form.requestSubmit();
    } else {
      form.reportValidity();
    }
  }

  openSpinner() {
    $('.overlay').addClass('show');
    $('.spanner').addClass('show');
  }
}
